export { }

const notifications = document.querySelectorAll(".i-notification")

notifications.forEach((notification) => {
  const closeButtons = notification.querySelectorAll(".i-notification__close")

  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener("click", () => notification.remove())
  })
})

window.addEventListener("load", () => {

  setTimeout(() => {
    notifications.forEach(notification => {
      notification.classList.remove("--hidden")
    });
  }, 1000);
});
